import { PartitionMode, ScopeReportLineItem } from '../ScopeReportTypes';

const partitionKeyAccessor: Record<PartitionMode, (item: ScopeReportLineItem) => string> = {
  group: item => item.groupId,
  trade: item => item.trade ?? 'Unknown Trade',
  contractorName: item => item.contractorName,
};

export const partitionDisplayNameAccessor: Record<PartitionMode, (item: ScopeReportLineItem) => string> = {
  group: item => item.groupName,
  trade: item => item.trade ?? 'Unknown Trade',
  contractorName: item => item.contractorName,
};

export const partitionLineItems = <T extends ScopeReportLineItem>(
  items: T[],
  partitionMode: PartitionMode,
): Record<string, T[]> =>
  items.reduce<Record<string, T[]>>((accumulator, item) => {
    const key = partitionKeyAccessor[partitionMode](item);
    (accumulator[key] ??= []).push(item);
    return accumulator;
  }, {});
